const OAUTH_RESERVED_PARAMETERS = ['access_token', 'session_state', 'state', 'iss', 'code']

/**
 * OIDC/OAuth query parameters reserved by the provider, stripped from the URL after login.
 */
export { OAUTH_RESERVED_PARAMETERS }
